const rankingItems = [
  { rank: 1, title: '某顶流男星深夜约会神秘女子', views: '1,286万', tag: '明星八卦', change: 'new' },
  { rank: 2, title: '综艺录制现场突发搞笑名场面', views: '998万', tag: '综艺热闻', change: 'up' },
  { rank: 3, title: '三大网红连环爆料引爆社交平台', views: '867万', tag: '网红动态', change: 'up' },
  { rank: 4, title: '年度影视口碑榜黑马逆袭登顶', views: '745万', tag: '影视盘点', change: 'same' },
  { rank: 5, title: '乐坛天王携新专回归破预售纪录', views: '632万', tag: '音乐动态', change: 'down' },
  { rank: 6, title: '国民品牌官宣新代言人引全网狂欢', views: '518万', tag: '品牌代言', change: 'up' },
  { rank: 7, title: '国际电影节红毯中国影人阵容豪华', views: '429万', tag: '电影节', change: 'new' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-2">
          瓜圈热度排行榜
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">本周最受关注的热门瓜讯 TOP 7</p>
        <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 truncate">{item.title}</h3>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-xs text-foreground-400">{item.views} 浏览</span>
                  <span className="px-1.5 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded">
                    {item.tag}
                  </span>
                </div>
              </div>

              <span className={`flex-shrink-0 text-xs font-medium ${
                item.change === 'up' ? 'text-primary-600' :
                item.change === 'new' ? 'text-accent-600' :
                item.change === 'down' ? 'text-foreground-400' :
                'text-secondary-500'
              }`}>
                {item.change === 'up' && '↑'}
                {item.change === 'down' && '↓'}
                {item.change === 'new' && 'NEW'}
                {item.change === 'same' && '—'}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}